import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class DealService {
  constructor(private restService: RestService) { }

  getSyndicationDeskList(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  saveDeal(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  saveBusiness(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetDeal(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetDealBusiness(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ChangeDealStatus(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetDealUpdateLog(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetDealUpdateBuyerLog(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  InviteOtherContacts(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ListNotes(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  saveNotes(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  deleteNote(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  saveNote(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  revokeConnectionAccess(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  changeDealStatus(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  viewDocumentLog(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  viewDealGroupDocumentLog(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  addDealPool(reqData, endPoint) {
    return this.restService.commonFileUpload(reqData, endPoint).pipe(map((res: any) => res));
  }
  getPoolDeals(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getPoolDealList(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  deletePoolDeals(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  editPoolDeals(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  addDealStatus(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  Getdealstatus(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getAllBuyerDeals(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  dealstatus(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  DownloadZipFile(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  duplicateDeal(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetZip(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  CheckBuyerContacts(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getInvitedBuyersList(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getInvitedBuyersDetails(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getInvestorReport(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getInvestorDealPoolReport(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  DealpoolInviteOtherContacts(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetPoolDealListDetails(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getInvitedBuyersdealpoollist(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  DealpoolRevokeConnectionAccess(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  savePoolNote(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  dealPoolListNotes(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  addDealPoolStatus(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getInvitedBuyersDealPoolListDetails(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  deletePoolNote(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getDealPoolstatus(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ViewDealPoolDocumentLog(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetSingleDealPoolDetail(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getAllBuyerPoolDeals(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  changeDealPoolStatus(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  buyerDocumentAccess(reqData) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getDeclinedReport(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getApprovedReport(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getFundedReport(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  UpdateDealPoolName(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  ViewUserDocumentLog(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  getFolder(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  notifyBuyer(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
}